if (!customElements.get('card-grid')) {
  class CardGrid extends HTMLElement {
    constructor() {
      super();

      this.manButton = this.querySelector('.product__gender button[data-gender="men"]');
      this.womanButton = this.querySelector('.product__gender button[data-gender="women"]');
      this.manGrid = this.querySelector('.card-grid__grid--man');
      this.womanGrid = this.querySelector('.card-grid__grid--woman');

      if (this.manButton && this.womanButton && this.manGrid && this.womanGrid) {
        this.manButton.addEventListener('click', this.setActiveGrid.bind(this, 'man'));
        this.womanButton.addEventListener('click', this.setActiveGrid.bind(this, 'woman'));
      }
    }

    setActiveGrid(gender) {
      if (gender === 'man') {
        this.manGrid.classList.add('active');
        this.womanGrid.classList.remove('active');
        this.manButton.classList.add('active');
        this.womanButton.classList.remove('active');
      } else {
        this.manGrid.classList.remove('active');
        this.womanGrid.classList.add('active');
        this.manButton.classList.remove('active');
        this.womanButton.classList.add('active');
      }
    }
  }

  customElements.define('card-grid', CardGrid)
}